import { getUserId, getUserName } from '../helpers';
import { api } from './api';

export function getCourseDetails(courseID, callback) {
  const data = {
    course_id: courseID,
  };

  api.ibledxcourses.getCourseOutline(data, (_data) => {
    callback(_data);
  });
}

export function getUserCourseCompletionApi(courseID, callback) {
  const data = {
    course_id: courseID,
    user_id: getUserId(),
  };
  api.ibldmcourses.getUserCourseCompletion(data, function (_data) {
    callback(_data);
  });
}

export function getUserProgress(courseID, callback) {
  const data = {
    user_id: getUserId(),
  };

  api.ibldmcourses.fetchUserProgress(data, function (data) {
    callback(data);
  });
}

export function getCourseGradeProgress(courseID, callback) {
  const data = {
    course_id: courseID,
    user_id: getUserId(),
  };

  api.ibledxcourses.get_user_course_grade_progress(data, callback);
}
